import React from 'react';
import BIFillFormAction from './BIFillFormAction';

class FillFormAction extends BIFillFormAction {
  constructor(props) {
    super(props);

    const { action, prefilledData = {} } = props;
    const { employee_fill_basic_information_form: { questions }, employee_information: ei = {} } = action;

    this.formConsumer = React.createRef();
    this.state = {
      questions: this.questionsWithAnswers(questions, prefilledData, ei),
      actionStatus: action.status,
      reviewState: false,
      emergencyContactConsent: ei.emergency_contact_consent || false,
      isEmployeeAction: true,
    };
  }
}

export default FillFormAction;
